import React from 'react';
import {Avatar, Button, Chip, TableCell, TableRow} from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Grid from "@mui/material/Grid2";
import {getRole} from "../../../../utils/roles";
import Constants from "../../../../utils/constants";

function ExploitantRow({exploitant, onEdit, onDelete, canDelete}) {
    return (
        <TableRow hover onClick={() => onEdit("user", exploitant.id)} style={{cursor: 'pointer'}}>
            <TableCell>
                <Chip label={getRole(exploitant.roles)} className={"chip-role-" + getRole(exploitant.roles)}/>
            </TableCell>
            <TableCell component="th">
                {exploitant.libelle}
            </TableCell>
            <TableCell className={"tableCell-logo"}>
                <Avatar src={Constants.API_ASSETS_USER_LOGO + exploitant.logo?.contentUrl}/>
            </TableCell>
            <TableCell>{exploitant.email}</TableCell>
            <TableCell></TableCell>
            <TableCell>
                {exploitant.isAccredited
                    ? <Button size="small" disabled className="toggle-button-small button-selected-green">Oui</Button>
                    : <Button size="small" disabled className="toggle-button-small button-selected-red">Non</Button>}
            </TableCell>
            <TableCell>
                <Grid container justify={"flex-end"} spacing={2}>
                    <Grid item>
                        <Button color="secondary" size="small"
                                onClick={(e) => { e.stopPropagation(); onEdit("user", exploitant.id); }}
                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                            Editer
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button color="error" size="small"
                                disabled={!canDelete(exploitant)}
                                onClick={(e) => { e.stopPropagation(); onDelete(exploitant); }}
                                startIcon={<CloseOutlinedIcon/>}>
                            Supprimer
                        </Button>
                    </Grid>
                </Grid>
            </TableCell>
        </TableRow>
    );
}

export default ExploitantRow;
